/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { OrganisationAdministrativeUpdateRequestToJSON, OrganisationCreationRequestToJSON, OrganisationRequestToJSON, OrganisationResponseFromJSON, PagedResponseOfOrganisationListEntryFromJSON, PagedResponseOfOrganisationUserListEntryFromJSON, } from '../models';
/**
 *
 */
var OrganisationRestControllerApi = /** @class */ (function (_super) {
    __extends(OrganisationRestControllerApi, _super);
    function OrganisationRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new organisation <p> \'Permission#CREATE_ORGANISATION\' is required to access to this endpoint
     * Create a new organisation <p> \'Permission#CREATE_ORGANISATION\' is required to access to this endpoint
     */
    OrganisationRestControllerApi.prototype.createOrganisationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organisationCreationRequest === null || requestParameters.organisationCreationRequest === undefined) {
                            throw new runtime.RequiredError('organisationCreationRequest', 'Required parameter requestParameters.organisationCreationRequest was null or undefined when calling createOrganisation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/organisations",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: OrganisationCreationRequestToJSON(requestParameters.organisationCreationRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return OrganisationResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new organisation <p> \'Permission#CREATE_ORGANISATION\' is required to access to this endpoint
     * Create a new organisation <p> \'Permission#CREATE_ORGANISATION\' is required to access to this endpoint
     */
    OrganisationRestControllerApi.prototype.createOrganisation = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createOrganisationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete organisation <p> \'Permission#DELETE_ORGANISATION\' is required to access to this endpoint
     * Delete organisation <p> \'Permission#DELETE_ORGANISATION\' is required to access to this endpoint
     */
    OrganisationRestControllerApi.prototype.deleteOrganisationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
                            throw new runtime.RequiredError('organisationId', 'Required parameter requestParameters.organisationId was null or undefined when calling deleteOrganisation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/organisations/{organisationId}".replace("{".concat("organisationId", "}"), encodeURIComponent(String(requestParameters.organisationId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete organisation <p> \'Permission#DELETE_ORGANISATION\' is required to access to this endpoint
     * Delete organisation <p> \'Permission#DELETE_ORGANISATION\' is required to access to this endpoint
     */
    OrganisationRestControllerApi.prototype.deleteOrganisation = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteOrganisationRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get organisation details <p> \'Permission#READ_ORGANISATION\' is required to access to this endpoint
     * Get organisation details <p> \'Permission#READ_ORGANISATION\' is required to access to this endpoint
     */
    OrganisationRestControllerApi.prototype.getOrganisationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
                            throw new runtime.RequiredError('organisationId', 'Required parameter requestParameters.organisationId was null or undefined when calling getOrganisation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/organisations/{organisationId}".replace("{".concat("organisationId", "}"), encodeURIComponent(String(requestParameters.organisationId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return OrganisationResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get organisation details <p> \'Permission#READ_ORGANISATION\' is required to access to this endpoint
     * Get organisation details <p> \'Permission#READ_ORGANISATION\' is required to access to this endpoint
     */
    OrganisationRestControllerApi.prototype.getOrganisation = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrganisationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List organisations using pagination <p> \'Permission#READ_ORGANISATION\' is required to access to this endpoint
     * List organisations using pagination <p> \'Permission#READ_ORGANISATION\' is required to access to this endpoint
     */
    OrganisationRestControllerApi.prototype.listOrganisationsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/organisations",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfOrganisationListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * List organisations using pagination <p> \'Permission#READ_ORGANISATION\' is required to access to this endpoint
     * List organisations using pagination <p> \'Permission#READ_ORGANISATION\' is required to access to this endpoint
     */
    OrganisationRestControllerApi.prototype.listOrganisations = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listOrganisationsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List users of a specific organisation using pagination <p> \'Permission#READ_ORGANISATION\' is required to access to this endpoint
     * List users of a specific organisation using pagination <p> \'Permission#READ_ORGANISATION\' is required to access to this endpoint
     */
    OrganisationRestControllerApi.prototype.listUsersOfOrganisationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
                            throw new runtime.RequiredError('organisationId', 'Required parameter requestParameters.organisationId was null or undefined when calling listUsersOfOrganisation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/organisations/{organisationId}/users".replace("{".concat("organisationId", "}"), encodeURIComponent(String(requestParameters.organisationId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfOrganisationUserListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * List users of a specific organisation using pagination <p> \'Permission#READ_ORGANISATION\' is required to access to this endpoint
     * List users of a specific organisation using pagination <p> \'Permission#READ_ORGANISATION\' is required to access to this endpoint
     */
    OrganisationRestControllerApi.prototype.listUsersOfOrganisation = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listUsersOfOrganisationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Patch (update) organisation role(s) of an organisation. <p> \'Permission#ADMINISTER_ORGANISATION\' is required to access to this endpoint
     * Patch (update) organisation role(s) of an organisation.
     */
    OrganisationRestControllerApi.prototype.patchOrganisationRoleRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
                            throw new runtime.RequiredError('organisationId', 'Required parameter requestParameters.organisationId was null or undefined when calling patchOrganisationRole.');
                        }
                        if (requestParameters.organisationAdministrativeUpdateRequest === null || requestParameters.organisationAdministrativeUpdateRequest === undefined) {
                            throw new runtime.RequiredError('organisationAdministrativeUpdateRequest', 'Required parameter requestParameters.organisationAdministrativeUpdateRequest was null or undefined when calling patchOrganisationRole.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/organisations/{organisationId}/role".replace("{".concat("organisationId", "}"), encodeURIComponent(String(requestParameters.organisationId))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: OrganisationAdministrativeUpdateRequestToJSON(requestParameters.organisationAdministrativeUpdateRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return OrganisationResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Patch (update) organisation role(s) of an organisation. <p> \'Permission#ADMINISTER_ORGANISATION\' is required to access to this endpoint
     * Patch (update) organisation role(s) of an organisation.
     */
    OrganisationRestControllerApi.prototype.patchOrganisationRole = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchOrganisationRoleRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update organisation details <p> \'Permission#UPDATE_ORGANISATION\' is required to access to this endpoint
     * Update organisation details <p> \'Permission#UPDATE_ORGANISATION\' is required to access to this endpoint
     */
    OrganisationRestControllerApi.prototype.updateOrganisationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
                            throw new runtime.RequiredError('organisationId', 'Required parameter requestParameters.organisationId was null or undefined when calling updateOrganisation.');
                        }
                        if (requestParameters.organisationRequest === null || requestParameters.organisationRequest === undefined) {
                            throw new runtime.RequiredError('organisationRequest', 'Required parameter requestParameters.organisationRequest was null or undefined when calling updateOrganisation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/organisations/{organisationId}".replace("{".concat("organisationId", "}"), encodeURIComponent(String(requestParameters.organisationId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: OrganisationRequestToJSON(requestParameters.organisationRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return OrganisationResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update organisation details <p> \'Permission#UPDATE_ORGANISATION\' is required to access to this endpoint
     * Update organisation details <p> \'Permission#UPDATE_ORGANISATION\' is required to access to this endpoint
     */
    OrganisationRestControllerApi.prototype.updateOrganisation = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOrganisationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return OrganisationRestControllerApi;
}(runtime.BaseAPI));
export { OrganisationRestControllerApi };
